/* SMC Outlook Agent Taskpane */
/* global Blob, document, fetch, localStorage, navigator, Office, URL, window */

// Frontend icinde API key tutmuyoruz. Tum AI cagrilari backend uzerinden yapilir.
const STORAGE_API_BASE = "smc-outlook-api-base";
const STORAGE_OUTPUT_LANGUAGE = "smc-outlook-output-language";
const STORAGE_TRANSLATE_TARGET = "smc-outlook-translate-target";
const STORAGE_AI_PROVIDER_MODE = "smc-outlook-ai-provider-mode";
const STORAGE_WIDE_OUTPUT = "smc-outlook-wide-output";
const STORAGE_WIDE_STATUS = "smc-outlook-wide-status";
const STORAGE_WIDE_SUBJECT = "smc-outlook-wide-subject";
const STORAGE_WIDE_SENDER = "smc-outlook-wide-sender";
const STORAGE_WIDE_ATTACHMENTS = "smc-outlook-wide-attachments";
const STORAGE_THEME_SNAPSHOT = "smc-outlook-theme-snapshot";
const STORAGE_REPLY_GUIDANCE = "smc-outlook-reply-guidance";
const STORAGE_MANUAL_SUBJECT = "smc-outlook-manual-subject";
const STORAGE_MANUAL_DRAFT = "smc-outlook-manual-draft";
const STORAGE_COMPOSE_TONE = "smc-outlook-compose-tone";
const DEFAULT_API_BASE = getDefaultApiBase();
const DEFAULT_OUTPUT_LANGUAGE = "bilingual";
const DEFAULT_TRANSLATE_TARGET = "en";
const DEFAULT_AI_PROVIDER_MODE = "auto";
const DEFAULT_COMPOSE_TONE = "balanced";
const MAX_ATTACHMENT_COUNT = 5;
const MAX_ATTACHMENT_BYTES = 2.5 * 1024 * 1024;
const MAX_TOTAL_ATTACHMENT_BYTES = 6 * 1024 * 1024;
const MAIL_CACHE_TTL_MS = 30000;
const MODE_BODY_CHAR_LIMITS = {
  "analyze-mail": 7000,
  "draft-reply": 6000,
  "extract-actions": 5500,
  "create-rca": 7000,
  "create-report": 6500,
  "polish-email": 9000,
  "writing-check": 9000,
  translate: 12000,
};
const SUPPORTED_ATTACHMENT_EXTENSIONS = [".pdf", ".docx", ".xlsx", ".csv", ".txt", ".log", ".eml"];
let currentMailCache = null;

Office.onReady((info) => {
  const runtimeStatus = document.getElementById("runtimeStatus");

  if (info.host === Office.HostType.Outlook) {
    runtimeStatus.textContent = "Outlook Ready";
    runtimeStatus.classList.add("ready");
    applyOfficeTheme();
    initializeUi();
    registerItemChangedHandler();
    registerThemeChangedHandler();
    refreshCurrentMailPreview();
  } else {
    runtimeStatus.textContent = "Not Outlook";
    setOutput("This add-in must run inside Outlook.");
  }
});

function initializeUi() {
  const apiBaseInput = document.getElementById("apiBaseInput");
  const languageSelect = document.getElementById("languageSelect");
  const translateSelect = document.getElementById("translateSelect");
  const aiProviderSelect = document.getElementById("aiProviderSelect");
  apiBaseInput.value = getApiBase();
  languageSelect.value = getOutputLanguage();
  translateSelect.value = getTranslateTargetLanguage();
  aiProviderSelect.value = getAiProviderMode();
  setupReplyGuidanceUi();
  setupManualDraftUi();
  setupHelpTooltips();

  document.getElementById("saveApiBaseBtn").addEventListener("click", () => {
    const apiBase = normalizeApiBase(apiBaseInput.value.trim() || DEFAULT_API_BASE);
    apiBaseInput.value = apiBase;
    localStorage.setItem(STORAGE_API_BASE, apiBase);
    setStatus("API base saved");
  });

  languageSelect.addEventListener("change", () => {
    localStorage.setItem(STORAGE_OUTPUT_LANGUAGE, normalizeOutputLanguage(languageSelect.value));
    setStatus("Language saved");
  });

  translateSelect.addEventListener("change", () => {
    localStorage.setItem(
      STORAGE_TRANSLATE_TARGET,
      normalizeTranslateTargetLanguage(translateSelect.value)
    );
    setStatus("Translate target saved");
  });

  aiProviderSelect.addEventListener("change", () => {
    localStorage.setItem(STORAGE_AI_PROVIDER_MODE, normalizeAiProviderMode(aiProviderSelect.value));
    setStatus(`AI mode: ${formatAiProviderMode(getAiProviderMode())}`);
  });

  document
    .getElementById("analyzeBtn")
    .addEventListener("click", () => runOperation("analyze-mail"));
  document
    .getElementById("analyzeAttachmentsBtn")
    .addEventListener("click", () => runOperation("analyze-mail", { includeAttachments: true }));
  document.getElementById("criticalScanBtn").addEventListener("click", runCriticalFolderScan);
  document.getElementById("draftBtn").addEventListener("click", runGuidedReplyOperation);
  document
    .getElementById("actionsBtn")
    .addEventListener("click", () => runOperation("extract-actions"));
  document.getElementById("rcaBtn").addEventListener("click", () => runOperation("create-rca"));
  document
    .getElementById("reportBtn")
    .addEventListener("click", () => runOperation("create-report"));
  document
    .getElementById("polishBtn")
    .addEventListener("click", () => runOperation("polish-email"));
  document
    .getElementById("writingCheckBtn")
    .addEventListener("click", () => runOperation("writing-check"));
  document
    .getElementById("translateBtn")
    .addEventListener("click", () => runOperation("translate"));
  document.getElementById("copyBtn").addEventListener("click", copyOutput);
  document.getElementById("copyReplyBtn").addEventListener("click", copyReply);
  document.getElementById("pdfBtn").addEventListener("click", exportPdf);
  document.getElementById("wideBtn").addEventListener("click", openWideView);
  document.getElementById("compactViewBtn").addEventListener("click", closeWidePanelView);
  document.getElementById("clearBtn").addEventListener("click", () => setOutput("Output cleared."));
}

function setupReplyGuidanceUi() {
  const replyGuidanceInput = document.getElementById("replyGuidanceInput");
  replyGuidanceInput.value = localStorage.getItem(STORAGE_REPLY_GUIDANCE) || "";

  replyGuidanceInput.addEventListener("input", () => {
    localStorage.setItem(STORAGE_REPLY_GUIDANCE, replyGuidanceInput.value);
  });

  document.getElementById("clearGuidanceBtn").addEventListener("click", clearReplyGuidance);
}

function setupManualDraftUi() {
  const manualSubjectInput = document.getElementById("manualSubjectInput");
  const manualDraftInput = document.getElementById("manualDraftInput");
  const savedTone = normalizeComposeTone(localStorage.getItem(STORAGE_COMPOSE_TONE));

  manualSubjectInput.value = localStorage.getItem(STORAGE_MANUAL_SUBJECT) || "";
  manualDraftInput.value = localStorage.getItem(STORAGE_MANUAL_DRAFT) || "";
  setSelectedComposeTone(savedTone);

  manualSubjectInput.addEventListener("input", () => {
    localStorage.setItem(STORAGE_MANUAL_SUBJECT, manualSubjectInput.value);
  });

  manualDraftInput.addEventListener("input", () => {
    localStorage.setItem(STORAGE_MANUAL_DRAFT, manualDraftInput.value);
  });

  document
    .getElementById("improveDraftBtn")
    .addEventListener("click", () => runManualDraftOperation("polish-email"));
  document
    .getElementById("insertToOutlookBtn")
    .addEventListener("click", insertGeneratedMessageToOutlook);
  document
    .getElementById("checkDraftBtn")
    .addEventListener("click", () => runManualDraftOperation("writing-check"));
  document.getElementById("copyDraftInputBtn").addEventListener("click", copyManualDraftInput);
  document.getElementById("clearDraftBtn").addEventListener("click", clearManualDraft);

  document.querySelectorAll('input[name="composeTone"]').forEach((input) => {
    input.addEventListener("change", () => {
      localStorage.setItem(STORAGE_COMPOSE_TONE, normalizeComposeTone(input.value));
      setStatus(`Tone: ${formatComposeTone(getComposeTone())}`);
    });
  });
}

function setupHelpTooltips() {
  const tooltip = document.getElementById("helpTooltip");
  const helpItems = document.querySelectorAll("[data-help]");

  helpItems.forEach((element) => {
    element.addEventListener("mouseenter", () => showHelpTooltip(element, tooltip));
    element.addEventListener("focus", () => showHelpTooltip(element, tooltip));
    element.addEventListener("mouseleave", () => hideHelpTooltip(tooltip));
    element.addEventListener("blur", () => hideHelpTooltip(tooltip));
  });
}

function showHelpTooltip(element, tooltip) {
  const text = element.getAttribute("data-help");

  if (!text || !tooltip) {
    return;
  }

  const rect = element.getBoundingClientRect();
  tooltip.textContent = text;
  tooltip.hidden = false;

  const tooltipRect = tooltip.getBoundingClientRect();
  const left = Math.min(Math.max(9, rect.left), window.innerWidth - tooltipRect.width - 9);
  const preferredTop = rect.bottom + 6;
  const top =
    preferredTop + tooltipRect.height < window.innerHeight
      ? preferredTop
      : Math.max(9, rect.top - tooltipRect.height - 6);

  tooltip.style.left = `${left}px`;
  tooltip.style.top = `${top}px`;
}

function hideHelpTooltip(tooltip) {
  if (tooltip) {
    tooltip.hidden = true;
  }
}

function registerItemChangedHandler() {
  const mailbox = Office.context.mailbox;

  if (!mailbox || !mailbox.addHandlerAsync || !Office.EventType.ItemChanged) {
    return;
  }

  // Taskpane pinlenince email degisiminde ekrandaki mevcut mail bilgilerini yeniler.
  mailbox.addHandlerAsync(Office.EventType.ItemChanged, () => {
    currentMailCache = null;
    setStatus("Mail changed");
    refreshCurrentMailPreview();
  });
}

function registerThemeChangedHandler() {
  const mailbox = Office.context.mailbox;

  if (!mailbox || !mailbox.addHandlerAsync || !Office.EventType.OfficeThemeChanged) {
    return;
  }

  // Outlook tema degisince panel renklerini Office host renkleriyle eslestirir.
  mailbox.addHandlerAsync(Office.EventType.OfficeThemeChanged, (event) => {
    applyOfficeTheme(event.officeTheme);
  });
}

async function refreshCurrentMailPreview() {
  try {
    const mail = await readCurrentMail();
    updateMailPreview(mail);
    setComposeMode(Boolean(mail.isCompose));

    if (mail.isCompose) {
      showComposeReadyState();
    }
  } catch (error) {
    if (isNoCurrentItemError(error)) {
      updateMailPreview(buildEmptyComposeMail());
      setComposeMode(true);
      showComposeReadyState();
      return;
    }

    setStatus("Mail read error");
    setOutput(`Mail could not be read.\n\n${error.message}`);
  }
}

async function readCurrentMail(options = {}) {
  const item = Office.context.mailbox.item;

  if (!item) {
    throw new Error("No Outlook item is currently selected.");
  }

  const isCompose = isComposeItem(item);
  const subject = await readItemSubject(item);
  const dateTimeCreated = toIsoDate(item.dateTimeCreated);
  const from = item.from || item.sender || {};
  const sender = {
    displayName: from.displayName || "",
    emailAddress: from.emailAddress || "",
  };
  const itemId = item.itemId || item.internetMessageId || "";
  const cacheKey = buildMailCacheKey(item, subject, itemId, dateTimeCreated);
  const cachedMail = isCompose ? null : getCachedMail(cacheKey, options);

  if (cachedMail) {
    return cachedMail;
  }

  const body = await readBodyText(item);
  const attachmentMetadata = readAttachmentMetadata(item);
  const attachments = options.includeAttachments
    ? await readAttachmentContents(item, attachmentMetadata)
    : attachmentMetadata;

  const mail = {
    subject,
    sender,
    body,
    itemId,
    conversationId: item.conversationId || "",
    internetMessageId: item.internetMessageId || "",
    dateTimeCreated,
    attachments,
    attachmentsIncluded: Boolean(options.includeAttachments),
    isCompose,
  };

  if (!options.includeAttachments && !isCompose) {
    currentMailCache = {
      key: cacheKey,
      createdAt: Date.now(),
      mail,
    };
  }

  return mail;
}

function buildEmptyComposeMail() {
  return {
    subject: "New email draft",
    sender: {
      displayName: "Ibrahim",
      emailAddress: "",
    },
    body: "",
    itemId: "",
    conversationId: "",
    internetMessageId: "",
    dateTimeCreated: "",
    attachments: [],
    attachmentsIncluded: false,
    isCompose: true,
  };
}

function isComposeItem(item) {
  return Boolean(item?.subject && typeof item.subject.getAsync === "function");
}

function readItemSubject(item) {
  if (typeof item.subject === "string") {
    return Promise.resolve(item.subject || "");
  }

  if (item.subject && typeof item.subject.getAsync === "function") {
    return readAsyncValue(item.subject.getAsync.bind(item.subject), "");
  }

  return Promise.resolve("");
}

function readAsyncValue(getAsync, fallback) {
  return new Promise((resolve) => {
    try {
      getAsync((result) => {
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
          resolve(fallback);
          return;
        }

        resolve(result.value || fallback);
      });
    } catch {
      resolve(fallback);
    }
  });
}

function isNoCurrentItemError(error) {
  return /No Outlook item/i.test(error?.message || "");
}

function showComposeReadyState() {
  const composeCard = document.getElementById("composeCard");
  const output = document.getElementById("output").textContent || "";

  setComposeMode(true);

  if (composeCard) {
    composeCard.open = true;
  }

  setStatus("New email ready");

  if (
    output.startsWith("Open an Outlook email") ||
    output.startsWith("Mail could not be read") ||
    output.startsWith("This add-in must run inside Outlook.")
  ) {
    setOutput(
      "Yeni email yazmak icin 'Yeni Email / Taslak Hazirla' alanina konu ve taslagini yaz.\n\n" +
        "Email Olustur: metni profesyonel TR+EN email haline getirir.\n" +
        "Outlook'a Yerlestir: hazir metni acik Outlook taslagina yazar, gondermez.\n" +
        "Mesaj: sadece gonderilecek email metnini kopyalar."
    );
  }
}

function setComposeMode(isComposeMode) {
  document.body.classList.toggle("compose-mode", Boolean(isComposeMode));
}

function buildMailCacheKey(item, subject, itemId, dateTimeCreated) {
  return [
    itemId,
    item.internetMessageId || "",
    item.conversationId || "",
    subject,
    dateTimeCreated,
  ].join("|");
}

function getCachedMail(cacheKey, options) {
  if (options.includeAttachments || !currentMailCache || currentMailCache.key !== cacheKey) {
    return null;
  }

  if (Date.now() - currentMailCache.createdAt > MAIL_CACHE_TTL_MS) {
    currentMailCache = null;
    return null;
  }

  return {
    ...currentMailCache.mail,
    sender: { ...currentMailCache.mail.sender },
    attachments: currentMailCache.mail.attachments.map((attachment) => ({ ...attachment })),
  };
}

function readBodyText(item) {
  return new Promise((resolve, reject) => {
    if (!item.body || typeof item.body.getAsync !== "function") {
      resolve("");
      return;
    }

    item.body.getAsync(Office.CoercionType.Text, (result) => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        reject(new Error(result.error ? result.error.message : "Body read failed."));
        return;
      }

      resolve(result.value || "");
    });
  });
}

function readAttachmentMetadata(item) {
  const attachments = Array.isArray(item.attachments) ? item.attachments : [];

  return attachments.map((attachment) => ({
    id: attachment.id || attachment.attachmentId || "",
    name: attachment.name || "Unnamed attachment",
    contentType: attachment.contentType || "",
    size: Number(attachment.size || 0),
    attachmentType: attachment.attachmentType || "",
    isInline: Boolean(attachment.isInline),
    status: "metadata-only",
  }));
}

async function readAttachmentContents(item, attachments) {
  if (!attachments.length) {
    return [];
  }

  if (typeof item.getAttachmentContentAsync !== "function") {
    return attachments.map((attachment) => ({
      ...attachment,
      status: "skipped",
      reason: "This Outlook client does not expose getAttachmentContentAsync.",
    }));
  }

  const results = [];
  let includedCount = 0;
  let totalBytes = 0;

  for (const attachment of attachments) {
    const base = { ...attachment, status: "pending" };

    if (attachment.isInline) {
      results.push({
        ...base,
        status: "skipped",
        reason: "Inline image/signature attachment skipped.",
      });
      continue;
    }

    if (!attachment.id) {
      results.push({ ...base, status: "skipped", reason: "Attachment ID is not available." });
      continue;
    }

    if (!isSupportedAttachmentName(attachment.name)) {
      results.push({
        ...base,
        status: "skipped",
        reason: "Unsupported attachment format for MVP.",
      });
      continue;
    }

    if (includedCount >= MAX_ATTACHMENT_COUNT) {
      results.push({ ...base, status: "skipped", reason: "Attachment count limit reached." });
      continue;
    }

    if (attachment.size > MAX_ATTACHMENT_BYTES) {
      results.push({
        ...base,
        status: "skipped",
        reason: "Attachment is larger than the MVP per-file limit.",
      });
      continue;
    }

    if (totalBytes + attachment.size > MAX_TOTAL_ATTACHMENT_BYTES) {
      results.push({ ...base, status: "skipped", reason: "Total attachment size limit reached." });
      continue;
    }

    try {
      const content = await getAttachmentContent(item, attachment);
      results.push({ ...base, ...content });

      if (content.status === "included") {
        includedCount += 1;
        totalBytes += attachment.size;
      }
    } catch (error) {
      results.push({ ...base, status: "error", error: error.message });
    }
  }

  return results;
}

function getAttachmentContent(item, attachment) {
  return new Promise((resolve, reject) => {
    item.getAttachmentContentAsync(attachment.id, (result) => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        reject(new Error(result.error ? result.error.message : "Attachment read failed."));
        return;
      }

      const value = result.value || {};
      const format = String(value.format || "");
      const content = String(value.content || "");

      if (!content) {
        resolve({ status: "error", format, error: "Attachment content is empty." });
        return;
      }

      if (isCloudAttachment(format, content)) {
        resolve({
          status: "cloud-url",
          format,
          contentUrl: content,
          reason: "Cloud attachment URL returned; MVP does not download external URLs.",
        });
        return;
      }

      if (isPlainContentFormat(format)) {
        resolve({ status: "included", format, contentText: content });
        return;
      }

      resolve({ status: "included", format, contentBase64: content });
    });
  });
}

async function runOperation(mode, options = {}) {
  setBusy(true);
  setStatus(options.includeAttachments ? "Reading mail and attachments..." : "Reading mail...");

  try {
    const mail = await readCurrentMail(options);
    const emailRefNo = buildClientReference(mail, mode);
    mail.clientRefNo = emailRefNo;
    mail.emailReference = emailRefNo;
    updateMailPreview(mail);

    setStatus(`Calling SMC API... ${emailRefNo}`);

    const result = await callSmcApi(mode, mail);

    setStatus(`Done | ${emailRefNo}`);
    setOutput(addReferenceToOutput(result.result || JSON.stringify(result, null, 2), emailRefNo));
  } catch (error) {
    setStatus("Error");
    setOutput(`Operation failed.\n\n${error.message}`);
  } finally {
    setBusy(false);
  }
}

async function runGuidedReplyOperation() {
  const replyGuidance = getReplyGuidance();

  if (!replyGuidance) {
    setStatus("Guidance needed");
    setOutput(
      "Cevap Yaz icin once Cevap Yonlendirmesi alanina ne demek istedigini yaz.\n\n" +
        "Ornek: Chief'e tesekkur et, alarm logu ve trend degerlerini iste, kesin karar vermeden once bizim onayimizi beklesin."
    );
    return;
  }

  setBusy(true);
  setStatus("Reading mail for guided reply...");

  try {
    const mail = await readCurrentMail();
    mail.replyGuidance = replyGuidance;
    mail.userDirectedReply = true;
    const emailRefNo = buildClientReference(mail, "draft-reply");
    mail.clientRefNo = emailRefNo;
    mail.emailReference = emailRefNo;
    updateMailPreview(mail);

    setStatus(`Creating guided reply... ${emailRefNo}`);
    const result = await callSmcApi("draft-reply", mail);

    setStatus(`Guided reply ready | ${emailRefNo}`);
    setOutput(addReferenceToOutput(result.result || JSON.stringify(result, null, 2), emailRefNo));
  } catch (error) {
    setStatus("Guided reply error");
    setOutput(`Guided reply failed.\n\n${error.message}`);
  } finally {
    setBusy(false);
  }
}

async function runCriticalFolderScan() {
  setBusy(true);
  setStatus("Tüm mail klasörleri analiz ediliyor...");

  try {
    const result = await callCriticalFolderScanApi();

    setStatus("Tüm mail klasör analizi tamamlandı");
    setOutput(result.result || JSON.stringify(result, null, 2));
  } catch (error) {
    setStatus("Tüm mail klasör analizi hata verdi");
    setOutput(`Tüm mail klasör analizi başarısız oldu.\n\n${error.message}`);
  } finally {
    setBusy(false);
  }
}

async function runManualDraftOperation(mode) {
  const { subject, draft, tone } = getManualDraftValues();

  if (!draft) {
    setStatus("Draft empty");
    setOutput("Write your email in New Email Draft, then click Improve Draft or Check Draft.");
    return;
  }

  setBusy(true);
  setStatus(
    mode === "writing-check"
      ? `Checking draft... ${formatComposeTone(tone)}`
      : `Improving draft... ${formatComposeTone(tone)}`
  );

  try {
    const referenceMail = await readCurrentMail().catch(() => null);

    if (referenceMail) {
      updateMailPreview(referenceMail);
    }

    // Manuel taslak modu: Outlook'a hicbir sey yazmaz, sadece backend'den duzeltilmis metin alir.
    const mail = buildManualDraftPayload(subject, draft, referenceMail, tone);
    const emailRefNo = buildClientReference(mail, mode);
    mail.clientRefNo = emailRefNo;
    mail.emailReference = emailRefNo;
    setManualReference(emailRefNo);
    const result = await callSmcApi(mode, mail);

    setStatus(`Draft ready | ${emailRefNo}`);
    setOutput(addReferenceToOutput(result.result || JSON.stringify(result, null, 2), emailRefNo));
  } catch (error) {
    setStatus("Draft error");
    setOutput(`Manual draft operation failed.\n\n${error.message}`);
  } finally {
    setBusy(false);
  }
}

function getManualDraftValues() {
  return {
    subject: normalizeClipboardText(document.getElementById("manualSubjectInput").value),
    draft: normalizeClipboardText(document.getElementById("manualDraftInput").value),
    tone: getComposeTone(),
  };
}

function getReplyGuidance() {
  return normalizeClipboardText(document.getElementById("replyGuidanceInput").value);
}

function getComposeTone() {
  const selected = document.querySelector('input[name="composeTone"]:checked');
  return normalizeComposeTone(
    selected ? selected.value : localStorage.getItem(STORAGE_COMPOSE_TONE)
  );
}

function setSelectedComposeTone(value) {
  const normalizedTone = normalizeComposeTone(value);
  const toneInputs = Array.from(document.querySelectorAll('input[name="composeTone"]'));
  const selectedInput =
    toneInputs.find((input) => input.value === normalizedTone) ||
    toneInputs.find((input) => input.value === DEFAULT_COMPOSE_TONE);

  if (selectedInput) {
    selectedInput.checked = true;
  }

  localStorage.setItem(STORAGE_COMPOSE_TONE, normalizedTone);
}

function normalizeComposeTone(value) {
  return ["balanced", "courteous", "direct", "technical", "commercial", "urgent"].includes(value)
    ? value
    : DEFAULT_COMPOSE_TONE;
}

function formatComposeTone(value) {
  const labels = {
    balanced: "Dengeli",
    courteous: "Nazik",
    direct: "Direkt",
    technical: "Teknik",
    commercial: "Ticari",
    urgent: "Acil",
  };

  return labels[normalizeComposeTone(value)] || labels[DEFAULT_COMPOSE_TONE];
}

function clearReplyGuidance() {
  document.getElementById("replyGuidanceInput").value = "";
  localStorage.removeItem(STORAGE_REPLY_GUIDANCE);
  setStatus("Guidance cleared");
}

function buildManualDraftPayload(subject, draft, referenceMail, tone) {
  const referenceSubject = referenceMail ? referenceMail.subject || "" : "";
  const payloadSubject =
    subject || (referenceSubject ? `Draft regarding: ${referenceSubject}` : "Manual email draft");
  const referenceSender = referenceMail ? referenceMail.sender || {} : {};

  return {
    subject: payloadSubject,
    sender: {
      displayName: "Manual Outlook Draft",
      emailAddress: "",
    },
    body: draft,
    itemId: referenceMail ? referenceMail.itemId || "" : "",
    conversationId: referenceMail ? referenceMail.conversationId || "" : "",
    internetMessageId: referenceMail ? referenceMail.internetMessageId || "" : "",
    dateTimeCreated: new Date().toISOString(),
    attachments: referenceMail ? referenceMail.attachments || [] : [],
    attachmentsIncluded: false,
    manualDraft: true,
    manualSubject: subject,
    manualDraftText: draft,
    composeTone: normalizeComposeTone(tone),
    referenceMail: referenceMail
      ? {
          subject: referenceSubject,
          sender: {
            displayName: referenceSender.displayName || "",
            emailAddress: referenceSender.emailAddress || "",
          },
          body: trimForApiContext(referenceMail.body),
          itemId: referenceMail.itemId || "",
          conversationId: referenceMail.conversationId || "",
          internetMessageId: referenceMail.internetMessageId || "",
        }
      : null,
  };
}

function trimForApiContext(value) {
  const text = normalizeClipboardText(value);
  const maxLength = 6000;

  if (text.length <= maxLength) {
    return text;
  }

  return `${text.slice(0, maxLength)}\n\n[Reference mail truncated for taskpane context]`;
}

function buildClientReference(mail, mode) {
  const subject = mail.subject || mail.manualSubject || "";
  const body = mail.manualDraftText || mail.replyGuidance || mail.body || "";
  const vesselCode = detectLocalVesselCode(`${subject}\n${body}`);
  const datePart = formatReferenceDate(mail.dateTimeCreated || Date.now());
  const hash = hashReference(
    `${mode}|${mail.itemId || ""}|${subject}|${body}|${mail.replyGuidance || ""}|${
      mail.composeTone || ""
    }`
  ).slice(0, 5);

  return `SMC-TUG-${vesselCode}-${datePart}-${hash}`;
}

function detectLocalVesselCode(value) {
  const text = String(value || "").toUpperCase();

  if (/\bOCEAN\s+DIAMOND\b|\bDIAMOND\b|\bODI\b|\bOX\b/.test(text)) {
    return "OX";
  }

  if (/\bOCEAN\s+FREEDOM\b|\bFREEDOM\b|\bOF\b/.test(text)) {
    return "OF";
  }

  if (/\bOCEAN\s+DESTINY\b|\bDESTINY\b|\bOD\b/.test(text)) {
    return "OD";
  }

  return "UNK";
}

function formatReferenceDate(value) {
  const date = new Date(value);
  const safeDate = Number.isNaN(date.getTime()) ? new Date() : date;

  return [
    safeDate.getFullYear(),
    String(safeDate.getMonth() + 1).padStart(2, "0"),
    String(safeDate.getDate()).padStart(2, "0"),
  ].join("");
}

function hashReference(value) {
  let hash = 0;
  const text = String(value || "");

  for (let index = 0; index < text.length; index += 1) {
    hash = (hash * 31 + text.charCodeAt(index)) >>> 0;
  }

  return hash.toString(16).toUpperCase().padStart(5, "0");
}

function addReferenceToOutput(output, refNo) {
  const text = String(output || "");

  if (!refNo || /\bEmail Ref No\s*:/i.test(text) || /^\s*Subject\s*:/i.test(text)) {
    return text;
  }

  return `Email Ref No: ${refNo}\n\n${text}`;
}

function setManualReference(refNo) {
  document.getElementById("manualRefNo").textContent = refNo || "not created yet";
}

function updateMailPreview(mail) {
  const subject = mail.subject || "-";
  const sender = mail.isCompose
    ? "New email / compose draft"
    : `${mail.sender.displayName || "-"} <${mail.sender.emailAddress || "-"}>`;
  const attachments = formatAttachmentSummary(mail.attachments);
  const refNo = mail.clientRefNo || buildClientReference(mail, "mail");

  document.getElementById("mailSubject").textContent = subject;
  document.getElementById("mailSender").textContent = sender;
  document.getElementById("mailAttachments").textContent = attachments;
  document.getElementById("mailRefNo").textContent = refNo;

  localStorage.setItem(STORAGE_WIDE_SUBJECT, subject);
  localStorage.setItem(STORAGE_WIDE_SENDER, sender);
  localStorage.setItem(STORAGE_WIDE_ATTACHMENTS, attachments);
}

function formatAttachmentSummary(attachments = []) {
  if (!attachments.length) {
    return "No attachments";
  }

  const names = attachments
    .slice(0, MAX_ATTACHMENT_COUNT)
    .map((attachment) => `${attachment.name} (${formatBytes(attachment.size)})`);
  const suffix =
    attachments.length > MAX_ATTACHMENT_COUNT
      ? ` +${attachments.length - MAX_ATTACHMENT_COUNT} more`
      : "";

  return `${attachments.length} attachment(s): ${names.join(", ")}${suffix}`;
}

async function callSmcApi(mode, mail) {
  const apiBase = getApiBase();
  const payload = preparePayloadForMode(mail, mode);

  const endpointMap = {
    "analyze-mail": "/api/outlook/analyze-mail",
    "draft-reply": "/api/outlook/draft-reply",
    "extract-actions": "/api/outlook/extract-actions",
    "create-rca": "/api/outlook/create-rca",
    "create-report": "/api/outlook/create-report",
    "polish-email": "/api/outlook/polish-email",
    "writing-check": "/api/outlook/writing-check",
    translate: "/api/outlook/translate",
  };

  const endpoint = endpointMap[mode];
  if (!endpoint) {
    throw new Error(`Unknown operation: ${mode}`);
  }

  const response = await fetch(`${apiBase}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...payload,
      mode,
      outputLanguage: getOperationOutputLanguage(mode),
      targetLanguage: getTranslateTargetLanguage(),
      aiProviderMode: getAiProviderMode(),
    }),
  });

  const data = await response.json().catch(() => null);

  if (!response.ok || !data) {
    throw new Error(data?.error || buildApiHttpError(response.status, apiBase));
  }

  if (data.ok === false) {
    throw new Error(data.error || "SMC API error");
  }

  return data;
}

function preparePayloadForMode(mail, mode) {
  const limit = MODE_BODY_CHAR_LIMITS[mode] || 7000;
  const payload = {
    ...mail,
    sender: { ...(mail.sender || {}) },
    attachments: Array.isArray(mail.attachments)
      ? mail.attachments.map((attachment) => ({ ...attachment }))
      : [],
  };

  if (!payload.manualDraft) {
    payload.body = limitPayloadText(payload.body, limit);
  }

  if (payload.referenceMail && payload.referenceMail.body) {
    payload.referenceMail = {
      ...payload.referenceMail,
      sender: { ...(payload.referenceMail.sender || {}) },
      body: limitPayloadText(payload.referenceMail.body, 5000),
    };
  }

  return payload;
}

function limitPayloadText(value, limit) {
  const text = String(value || "");

  if (text.length <= limit) {
    return text;
  }

  const marker = "\n\n[SMC note: middle content shortened for faster taskpane processing.]\n\n";
  const headLength = Math.max(0, Math.floor(limit * 0.72));
  const tailLength = Math.max(0, limit - headLength - marker.length);

  return `${text.slice(0, headLength)}${marker}${text.slice(-tailLength)}`;
}

async function callCriticalFolderScanApi() {
  const apiBase = getApiBase();
  const response = await fetch(`${apiBase}/api/outlook/critical-folder-scan`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      outputLanguage: getOutputLanguage(),
      aiProviderMode: getAiProviderMode(),
    }),
  });

  const data = await response.json().catch(() => null);

  if (!response.ok || !data) {
    throw new Error(data?.error || buildApiHttpError(response.status, apiBase));
  }

  if (data.ok === false) {
    throw new Error(data.error || "SMC API error");
  }

  return data;
}

function getApiBase() {
  const savedApiBase = localStorage.getItem(STORAGE_API_BASE) || DEFAULT_API_BASE;
  const apiBase = normalizeApiBase(savedApiBase);

  if (apiBase !== savedApiBase) {
    localStorage.setItem(STORAGE_API_BASE, apiBase);
  }

  return apiBase;
}

function getDefaultApiBase() {
  const location = window.location;

  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    return "https://localhost:4000";
  }

  return location.origin;
}

function getOutputLanguage() {
  return normalizeOutputLanguage(localStorage.getItem(STORAGE_OUTPUT_LANGUAGE));
}

function getOperationOutputLanguage(mode) {
  if (["draft-reply", "polish-email", "writing-check"].includes(mode)) {
    return "bilingual";
  }

  return getOutputLanguage();
}

function getTranslateTargetLanguage() {
  return normalizeTranslateTargetLanguage(localStorage.getItem(STORAGE_TRANSLATE_TARGET));
}

function getAiProviderMode() {
  return normalizeAiProviderMode(localStorage.getItem(STORAGE_AI_PROVIDER_MODE));
}

function normalizeOutputLanguage(value) {
  return ["tr", "en", "bilingual"].includes(value) ? value : DEFAULT_OUTPUT_LANGUAGE;
}

function normalizeTranslateTargetLanguage(value) {
  return ["tr", "en"].includes(value) ? value : DEFAULT_TRANSLATE_TARGET;
}

function normalizeAiProviderMode(value) {
  return ["auto", "openai", "claude"].includes(value) ? value : DEFAULT_AI_PROVIDER_MODE;
}

function formatAiProviderMode(value) {
  const labels = {
    auto: "Auto",
    openai: "OpenAI",
    claude: "Claude",
  };

  return labels[normalizeAiProviderMode(value)];
}

function normalizeApiBase(value) {
  try {
    const url = new URL(value || DEFAULT_API_BASE);

    // 3100 taskpane server'idir; API endpointleri 4000 backend uzerindedir.
    if (url.hostname === "localhost" && url.port === "3100") {
      return DEFAULT_API_BASE;
    }

    url.pathname = "";
    url.search = "";
    url.hash = "";
    return url.toString().replace(/\/$/, "");
  } catch {
    return DEFAULT_API_BASE;
  }
}

function buildApiHttpError(status, apiBase) {
  if (status === 404) {
    return `SMC API returned HTTP 404. API Base URL must be ${DEFAULT_API_BASE}, current value is ${apiBase}.`;
  }

  return `SMC API returned HTTP ${status}`;
}

function isSupportedAttachmentName(name = "") {
  const lowerName = name.toLowerCase();
  return SUPPORTED_ATTACHMENT_EXTENSIONS.some((extension) => lowerName.endsWith(extension));
}

function isPlainContentFormat(format) {
  return /eml|icalendar|text/i.test(format);
}

function isCloudAttachment(format, content) {
  return /url/i.test(format) || /^https?:\/\//i.test(content);
}

function formatBytes(bytes) {
  if (!bytes) {
    return "unknown size";
  }

  if (bytes < 1024) {
    return `${bytes} B`;
  }

  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }

  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

function toIsoDate(value) {
  if (!value) {
    return "";
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
}

function setOutput(text) {
  const output = text || "";
  document.getElementById("output").textContent = output;
  localStorage.setItem(STORAGE_WIDE_OUTPUT, output);
}

function setStatus(text) {
  document.getElementById("operationStatus").textContent = text;
  localStorage.setItem(STORAGE_WIDE_STATUS, text);
}

function setBusy(isBusy) {
  const ids = [
    "analyzeBtn",
    "analyzeAttachmentsBtn",
    "criticalScanBtn",
    "draftBtn",
    "clearGuidanceBtn",
    "actionsBtn",
    "rcaBtn",
    "reportBtn",
    "polishBtn",
    "writingCheckBtn",
    "translateBtn",
    "improveDraftBtn",
    "insertToOutlookBtn",
    "checkDraftBtn",
    "copyDraftInputBtn",
    "clearDraftBtn",
    "copyReplyBtn",
    "pdfBtn",
  ];

  ids.forEach((id) => {
    document.getElementById(id).disabled = isBusy;
  });
}

function applyOfficeTheme(theme = Office.context.officeTheme) {
  const colors = buildThemeColors(theme);

  if (!colors) {
    return;
  }

  const root = document.documentElement;
  Object.keys(colors.variables).forEach((name) => {
    root.style.setProperty(name, colors.variables[name]);
  });

  document.body.classList.toggle("smc-theme-dark", colors.isDark);
  document.body.classList.toggle("smc-theme-light", !colors.isDark);
  localStorage.setItem(STORAGE_THEME_SNAPSHOT, JSON.stringify(colors));
}

function buildThemeColors(theme) {
  if (!theme || !isHexColor(theme.bodyBackgroundColor) || !isHexColor(theme.bodyForegroundColor)) {
    return null;
  }

  const bg = normalizeHexColor(theme.bodyBackgroundColor);
  const text = normalizeHexColor(theme.bodyForegroundColor);
  const controlBg = isHexColor(theme.controlBackgroundColor)
    ? normalizeHexColor(theme.controlBackgroundColor)
    : bg;
  const controlText = isHexColor(theme.controlForegroundColor)
    ? normalizeHexColor(theme.controlForegroundColor)
    : text;
  const isDark = getColorLuminance(bg) < 0.45;
  const variables = isDark
    ? {
        "--bg": bg,
        "--card": mixHexColors(controlBg, "#ffffff", 0.05),
        "--card2": mixHexColors(controlBg, "#ffffff", 0.1),
        "--pre-bg": mixHexColors(bg, "#000000", 0.22),
        "--text": text,
        "--muted": mixHexColors(text, bg, 0.36),
        "--border": "rgba(255, 255, 255, 0.14)",
        "--button-primary-text": "#04111a",
        "--button-assist-bg": "rgba(0, 196, 255, 0.15)",
        "--button-assist-border": "rgba(0, 196, 255, 0.36)",
        "--button-assist-text": text,
        "--shadow": "rgba(0, 0, 0, 0.2)",
      }
    : {
        "--bg": bg,
        "--card": mixHexColors(controlBg, "#ffffff", 0.62),
        "--card2": mixHexColors(controlBg, "#000000", 0.05),
        "--pre-bg": mixHexColors(controlBg, "#ffffff", 0.8),
        "--text": text,
        "--muted": mixHexColors(text, bg, 0.45),
        "--border": "rgba(0, 0, 0, 0.14)",
        "--button-primary-text": "#031018",
        "--button-assist-bg": "rgba(0, 144, 192, 0.1)",
        "--button-assist-border": "rgba(0, 144, 192, 0.32)",
        "--button-assist-text": controlText,
        "--shadow": "rgba(0, 0, 0, 0.06)",
      };

  return { isDark, variables };
}

function isHexColor(value) {
  return /^#[0-9a-f]{6}$/i.test(String(value || ""));
}

function normalizeHexColor(value) {
  return String(value).toUpperCase();
}

function mixHexColors(baseColor, blendColor, blendWeight) {
  const base = hexToRgb(baseColor);
  const blend = hexToRgb(blendColor);
  const weight = Math.max(0, Math.min(1, blendWeight));

  return rgbToHex({
    r: Math.round(base.r * (1 - weight) + blend.r * weight),
    g: Math.round(base.g * (1 - weight) + blend.g * weight),
    b: Math.round(base.b * (1 - weight) + blend.b * weight),
  });
}

function getColorLuminance(hexColor) {
  const rgb = hexToRgb(hexColor);
  const values = [rgb.r, rgb.g, rgb.b].map((channel) => {
    const normalized = channel / 255;
    return normalized <= 0.03928 ? normalized / 12.92 : Math.pow((normalized + 0.055) / 1.055, 2.4);
  });

  return 0.2126 * values[0] + 0.7152 * values[1] + 0.0722 * values[2];
}

function hexToRgb(hexColor) {
  const normalized = normalizeHexColor(hexColor).replace("#", "");
  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16),
  };
}

function rgbToHex(rgb) {
  return `#${toHexPair(rgb.r)}${toHexPair(rgb.g)}${toHexPair(rgb.b)}`;
}

function toHexPair(value) {
  return value.toString(16).padStart(2, "0").toUpperCase();
}

async function copyOutput() {
  const text = document.getElementById("output").textContent || "";

  try {
    await navigator.clipboard.writeText(text);
    setStatus("Copied");
  } catch {
    setStatus(fallbackCopy(text) ? "Copied" : "Copy failed");
  }
}

async function copyManualDraftInput() {
  const { draft } = getManualDraftValues();

  if (!draft) {
    setStatus("Draft empty");
    return;
  }

  try {
    await navigator.clipboard.writeText(draft);
    setStatus("Draft copied");
  } catch {
    setStatus(fallbackCopy(draft) ? "Draft copied" : "Copy failed");
  }
}

function clearManualDraft() {
  document.getElementById("manualSubjectInput").value = "";
  document.getElementById("manualDraftInput").value = "";
  localStorage.removeItem(STORAGE_MANUAL_SUBJECT);
  localStorage.removeItem(STORAGE_MANUAL_DRAFT);
  setManualReference("");
  setStatus("Draft cleared");
}

function openWideView() {
  const wideUrl = new URL("wide.html", window.location.href).toString();
  const ui = Office.context && Office.context.ui;

  // Yeni Outlook paneli dar kaldiginda sonucu genis Office dialogunda acar.
  // Dialog acilamazsa ayni taskpane icinde tam-yukseklik okuma moduna gecer.
  if (ui && typeof ui.displayDialogAsync === "function") {
    ui.displayDialogAsync(wideUrl, { height: 90, width: 90, displayInIframe: false }, (result) => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        openWidePanelView();
        return;
      }

      setStatus("Large view opened");
    });
    return;
  }

  const opened = window.open(wideUrl, "_blank", "noopener,noreferrer");

  if (!opened) {
    openWidePanelView();
    return;
  }

  setStatus("Large view opened");
}

function openWidePanelView() {
  document.body.classList.add("wide-output-mode");
  setStatus("Large view in panel");
}

function closeWidePanelView() {
  document.body.classList.remove("wide-output-mode");
  setStatus("Panel view");
}

async function copyReply() {
  const text = document.getElementById("output").textContent || "";
  const replyText = extractReplyText(text);

  if (!replyText) {
    setStatus("No reply text");
    return;
  }

  try {
    await navigator.clipboard.writeText(replyText);
    setStatus("Reply copied");
  } catch {
    setStatus(fallbackCopy(replyText) ? "Reply copied" : "Copy failed");
  }
}

async function insertGeneratedMessageToOutlook() {
  const item = Office.context.mailbox.item;
  const outputText = document.getElementById("output").textContent || "";
  const generatedMessage = extractReplyText(outputText);

  if (!item || !isComposeItem(item)) {
    setStatus("Open new email first");
    setOutput(
      "Outlook'a yerlestirmek icin once New Email / Reply penceresinde SMC Agent'i ac.\n\n" +
        "Bu buton email gondermez; sadece acik taslagin subject/body alanlarini doldurur."
    );
    return;
  }

  if (!generatedMessage) {
    setStatus("No generated message");
    setOutput(
      "Once Email Olustur veya Yazim Kontrol ile SMC Output icinde Subject, Email Ref No ve TR/EN metni olustur."
    );
    return;
  }

  const draftParts = extractOutlookDraftParts(generatedMessage, outputText);

  if (!draftParts.body) {
    setStatus("Draft body empty");
    return;
  }

  setBusy(true);
  setStatus("Writing to Outlook draft...");

  try {
    await setComposeSubject(item, draftParts.subject);
    await setComposeBody(item, draftParts.body);
    setStatus("Outlook draft updated");
  } catch (error) {
    setStatus("Outlook insert error");
    setOutput(`${outputText}\n\nOutlook draft insert failed.\n${error.message}`);
  } finally {
    setBusy(false);
  }
}

function extractOutlookDraftParts(generatedMessage, sourceText) {
  const lines = normalizeClipboardText(generatedMessage).split(/\n/);
  const bodyLines = [];
  let subject = "";

  lines.forEach((line) => {
    const subjectMatch = /^Subject\s*:\s*(.*)$/i.exec(line.trim());

    if (subjectMatch && !subject) {
      subject = subjectMatch[1].trim();
      return;
    }

    bodyLines.push(line);
  });

  const fallbackSubject =
    extractReplySubject(sourceText) ||
    normalizeClipboardText(document.getElementById("manualSubjectInput").value);

  return {
    subject: subject || fallbackSubject,
    body: bodyLines.join("\n").replace(/^\n+/, "").trim(),
  };
}

function setComposeSubject(item, subject) {
  return new Promise((resolve, reject) => {
    if (!subject || !item.subject || typeof item.subject.setAsync !== "function") {
      resolve();
      return;
    }

    item.subject.setAsync(subject, (result) => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        reject(new Error(result.error ? result.error.message : "Subject update failed."));
        return;
      }

      resolve();
    });
  });
}

function setComposeBody(item, body) {
  return new Promise((resolve, reject) => {
    if (!item.body || typeof item.body.setAsync !== "function") {
      reject(new Error("This Outlook client does not allow body update from the taskpane."));
      return;
    }

    item.body.setAsync(body, { coercionType: Office.CoercionType.Text }, (result) => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        reject(new Error(result.error ? result.error.message : "Body update failed."));
        return;
      }

      resolve();
    });
  });
}

async function exportPdf() {
  const output = document.getElementById("output").textContent || "";

  if (!isExportableOutput(output)) {
    setStatus("No PDF content");
    return;
  }

  setBusy(true);
  setStatus("Creating PDF...");

  try {
    const pdf = await callPdfApi({
      title: "SMC Outlook Agent Output",
      subject: document.getElementById("mailSubject").textContent || "-",
      sender: document.getElementById("mailSender").textContent || "-",
      output,
      outputLanguage: getOutputLanguage(),
    });

    downloadBase64File(pdf.fileName, pdf.mimeType, pdf.contentBase64);
    setStatus("PDF ready");
  } catch (error) {
    setStatus("PDF error");
    setOutput(`${output}\n\nPDF export failed.\n${error.message}`);
  } finally {
    setBusy(false);
  }
}

async function callPdfApi(payload) {
  const apiBase = getApiBase();
  const response = await fetch(`${apiBase}/api/outlook/create-pdf`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => null);

  if (!response.ok || !data) {
    throw new Error(data?.error || buildApiHttpError(response.status, apiBase));
  }

  if (data.ok === false) {
    throw new Error(data.error || "SMC API error");
  }

  return data;
}

function downloadBase64File(fileName, mimeType, contentBase64) {
  const byteCharacters = window.atob(contentBase64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);
    const byteNumbers = Array.from(slice, (character) => character.charCodeAt(0));
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  const blob = new Blob(byteArrays, { type: mimeType || "application/pdf" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "SMC-Outlook-Output.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function extractReplyText(source) {
  const text = normalizeClipboardText(source);

  if (!isExportableOutput(text)) {
    return "";
  }

  const markedReply = extractAfterReplyMarker(text);
  const candidate = markedReply || extractFromSubjectLine(text) || focusOnEmailBody(text);
  const subject = extractReplySubject(text);
  const refNo = extractEmailReference(text);
  const cleaned = stripReplyMetadata(trimReplyTail(candidate));
  const replyBody = buildCopyReadyReply(cleaned, subject, refNo);

  return replyBody;
}

function extractEmailReference(text) {
  const match =
    /Email Ref No\s*:\s*(SMC-(?:TUG-)?[A-Z0-9]+(?:-[A-Z0-9]+)?-\d{8}-[A-F0-9]{5})/i.exec(text);
  return match ? match[1].toUpperCase() : "";
}

function extractReplySubject(text) {
  const lines = normalizeClipboardText(text).split(/\n/);

  for (let index = 0; index < lines.length; index += 1) {
    const line = lines[index].trim();
    const match =
      /^(Subject|Recommended Subject|Corrected Subject|Onerilen Konu)\s*:?\s*(.*)$/i.exec(line);

    if (!match) {
      continue;
    }

    if (match[2]) {
      return match[2].trim();
    }

    const nextLine = lines.slice(index + 1).find((item) => item.trim());
    if (nextLine && !/^(Email Ref No|TR|EN|SMC Internal Note)\s*:/i.test(nextLine.trim())) {
      return nextLine.trim();
    }
  }

  return "";
}

function buildCopyReadyReply(replyBody, subject, refNo) {
  const body = normalizeClipboardText(replyBody)
    .split(/\n/)
    .filter((line) => {
      const cleanLine = line.trim();
      return !/^(Subject|Recommended Subject|Corrected Subject|Onerilen Konu|Email Ref No)\s*:/i.test(
        cleanLine
      );
    })
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  if (!body) {
    return "";
  }

  const headerLines = [];

  if (subject) {
    headerLines.push(`Subject: ${subject}`);
  }

  if (refNo) {
    headerLines.push(`Email Ref No: ${refNo}`);
  }

  return [...headerLines, "", body]
    .filter((line, index, lines) => {
      return line || (index > 0 && index < lines.length - 1);
    })
    .join("\n");
}

function extractAfterReplyMarker(text) {
  const markers = [
    /Outlook Copy-Paste Text\s*:?\s*/i,
    /Outlook'a Yapistirilacak Son Metin\s*:?\s*/i,
    /Final Copy-Paste Text\s*:?\s*/i,
    /Copy-Paste Message\s*:?\s*/i,
    /Final Outlook Message\s*:?\s*/i,
    /EN\s*-\s*Corrected Copy-Paste Text\s*:?\s*/i,
    /EN\s*-\s*Professional Draft Reply\s*:?\s*/i,
    /Professional English Draft Reply\s*:?\s*/i,
    /Corrected Professional Email\s*:?\s*/i,
    /Corrected Email\s*:?\s*/i,
    /Corrected Professional Body\s*:?\s*/i,
    /DRAFT REPLY\s*-\s*MANUAL APPROVAL REQUIRED\s*/i,
    /Draft Reply\s*:?\s*/i,
  ];

  for (const marker of markers) {
    const match = marker.exec(text);

    if (match) {
      return text.slice(match.index + match[0].length).trim();
    }
  }

  return "";
}

function extractFromSubjectLine(text) {
  const match = /(^|\n)\s*Subject\s*:/i.exec(text);

  if (!match) {
    return "";
  }

  return text.slice(match.index).trim();
}

function trimReplyTail(text) {
  const stops = [
    /\n\s*SMC Internal Note\s*:?\s*/i,
    /\n\s*TR\s*-\s*Ic Not\s*:?\s*/i,
    /\n\s*TR\s*-\s*Yazim Denetimi\s*:?\s*/i,
    /\n\s*Internal Turkish Note\s*:?\s*/i,
    /\n\s*Turkish Internal Note\s*:?\s*/i,
    /\n\s*Maritime Terminology Notes\s*:?\s*/i,
    /\n\s*Quality Warning\s*:?\s*/i,
  ];
  let endIndex = text.length;

  stops.forEach((stop) => {
    const match = stop.exec(text);

    if (match && match.index > 0 && match.index < endIndex) {
      endIndex = match.index;
    }
  });

  return text.slice(0, endIndex).trim();
}

function stripReplyMetadata(text) {
  return text
    .split(/\r?\n/)
    .filter((line) => {
      const cleanLine = line.trim();
      return !/^(DRAFT REPLY|Manual Approval|LANGUAGE MODE|TR Not|EN Note)/i.test(cleanLine);
    })
    .join("\n")
    .trim();
}

function focusOnEmailBody(text) {
  const match = /(^|\n)\s*(Dear|Chief Engineer|Master|Captain|Good day|Hello)\b/i.exec(text);

  if (!match) {
    return text;
  }

  return text.slice(match.index).trim();
}

function normalizeClipboardText(value) {
  return String(value || "")
    .replace(/\r/g, "\n")
    .replace(/\n{4,}/g, "\n\n\n")
    .trim();
}

function isExportableOutput(value) {
  const text = normalizeClipboardText(value);

  return Boolean(
    text &&
    text !== "Output cleared." &&
    !text.startsWith("Open an Outlook email") &&
    !text.startsWith("This add-in must run inside Outlook.")
  );
}

function fallbackCopy(text) {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand("copy");
  document.body.removeChild(textarea);
  return copied;
}
